import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { aboutValues } from "@/mocks/aboutData";

export default function ValuesSection() {
  return (
    <section className="bg-white py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <ScrollReveal>
            <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-4 md:mb-5">
                <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
                  / Core Values
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-5xl font-bold text-tie-text-primary leading-tight">
                Principles That Guide Every Decision
              </h2>
              <p className="mt-3 md:mt-4 text-base md:text-lg text-tie-text-secondary">
                TIE's culture, governance, and programmes are anchored in six
                non-negotiable values.
              </p>
            </div>
          </ScrollReveal>

          {/* Values Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {aboutValues.map((value, index) => (
              <ScrollReveal key={value.title} delay={index * 100}>
                <div className="h-full p-5 md:p-6 rounded-xl bg-tie-grey-light border border-tie-grey-dark hover:border-tie-teal/30 transition-all duration-300">
                  <div className="flex items-center gap-3 mb-3 md:mb-4">
                    <div className="w-9 h-9 rounded-lg bg-tie-navy/10 flex items-center justify-center">
                      <i className={`${value.icon} text-tie-navy text-base`} />
                    </div>
                    <h3 className="text-base md:text-lg font-semibold text-tie-text-primary">
                      {value.title}
                    </h3>
                  </div>
                  <p className="text-sm text-tie-text-secondary leading-relaxed">
                    {value.description}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}